import { createConfirmation } from "react-confirm";

import { ConfirmDialog } from "../../components/shared/dialogs/index.js";

export default (title, options = {}) => createConfirmation(ConfirmDialog)({ title, ...options });
